import {HttpRequest} from '../../settings/HttpRequest/HttpRequest';

export const GoogleDriveService = {
	Listar: (ruta, item_id) => {
		let params = {
			ruta: ruta || null,
			item_id: item_id || null
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	ListarControl: (filtro, paginacion) => {
		let params = {
			filtro: {
				nombre: filtro.nombre || '',
				tipo: filtro.tipo || '',
				ruta: filtro.ruta || '',
				activo: (Number(filtro.activo) === 1 || Number(filtro.activo) === 0) ? Number(filtro.activo) : 1,
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Control', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			ruta: form.ruta || '',
			nombre: form.nombre || '',
			archivo: form.archivo || '',
			parent_id: form.parent_id || '',
			archivos: form.archivos || []
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	AgregarFolder: (form) => {
		let params = {
			nombre: form.nombre || '',
			ruta: form.ruta || '',
			parent_id: form.parent_id || ''
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Guardar_Folder', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Descargar: (form) => {
		let params = {
			item_id: form.item_id || '',
			ruta: form.ruta || form.path_display || '',
			nombre: form.nombre || form.name || '',
			incluir_contenido: form.incluir_contenido ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Descargar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			item_id: form.item_id || '',
			nombre: form.nombre || '',
			ruta: form.ruta || '',
			parent_id: form.parent_id || ''
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (form) => {
		let params = {
			item_id: form.item_id || '',
			id_google_drive: form.id_google_drive || '',
			ruta: form.ruta || form.path_display || '',
			nombre: form.nombre || form.name || ''
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Compartir: (form) => {
		let params = {
			item_id: form.item_id || '',
			tipo: form.tipo || 'view'
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Compartir', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Activo: (form) => {
		let params = {
			id_google_drive: form.id_google_drive || '',
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Google_Drive_Activo', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
